var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 1.31241C15.5734 1.31241 19.6877 5.42673 19.6877 10.5C19.6877 15.5733 15.5734 19.6876 10.5001 19.6876C5.42682 19.6876 1.3125 15.5733 1.3125 10.5C1.3125 5.42673 5.42682 1.31241 10.5001 1.31241ZM9.5158 11.2906V6.56187C9.5158 6.01976 9.958 5.57757 10.5001 5.57757C11.0422 5.57757 11.4844 6.02387 11.4844 6.56187V11.2906C11.4844 11.8286 11.0422 12.2749 10.5001 12.2749C9.95799 12.2749 9.5158 11.8327 9.5158 11.2906ZM10.4958 13.3306C11.1119 13.3306 11.6115 13.8302 11.6115 14.4462C11.6115 15.0623 11.1119 15.5619 10.4958 15.5619C9.87987 15.5619 9.38024 15.0623 9.38024 14.4462C9.38024 13.8302 9.87987 13.3306 10.4958 13.3306Z",
    fill: "#F16A65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleError);
export default __webpack_public_path__ + "static/media/exclamation-circle-error.bd6ecd1a380c9cba220f28807ba1255c.svg";
export { ForwardRef as ReactComponent };